const redirectUrlsAllowed = [
  "/change_password",
  "/client_rewards_accept",
  "/client_rewards_expired",
  "/create_account",
  "/onboard",
  "/referral",
  "/reset_password",
  "/settings",
  "/training"
]

const isAllowedUrl = (redirect) =>
  redirect === "/" || redirectUrlsAllowed.some((element) => redirect.startsWith(element))

export const sanitizeRedirect = () => {
  const params = new URLSearchParams(window.location.search)
  let location = "/"
  let redirect = params.get("redirect")
  if (redirect) {
    params.delete("redirect")
    redirect = new URL(redirect, document.baseURI).pathname
    location = isAllowedUrl(redirect) ? redirect : "/"
  }
  const paramsExist = Array.from(params).length > 0
  const newParams = paramsExist ? `?${params}` : ""
  return `${location}${newParams}`
}
